import { render } from "./ed-organism-in-page-navigation.vue?vue&type=template&id=6749cbc8"
import script from "./ed-organism-in-page-navigation.vue?vue&type=script&lang=js"
export * from "./ed-organism-in-page-navigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__